import React, {useContext} from "react";
import {LabelContext} from "../../assets/js/labelDataContext";

const OrderSend = (props) => {
    const val = useContext(LabelContext);
    const isSend = val.labelInfo.isSend;

    return (
        <div className="row">
            <div className="col-12">
                <h1 className="text-success text-center">Dziękujemy za złożenie zamówienia</h1>
                <h4 className="text-center">Potwierdzenie zostało wysłane na email</h4>
            </div>
        </div>
    );
};
export default OrderSend;

